var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarsSolidFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 640 640",
    style: {
      enableBackground: "new 0 0 640 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96,160c0-17.7,14.3-32,32-32h384c17.7,0,32,14.3,32,32s-14.3,32-32,32H128C110.3,192,96,177.7,96,160z M96,320 c0-17.7,14.3-32,32-32h384c17.7,0,32,14.3,32,32s-14.3,32-32,32H128C110.3,352,96,337.7,96,320z M544,480c0,17.7-14.3,32-32,32H128 c-17.7,0-32-14.3-32-32s14.3-32,32-32h384C529.7,448,544,462.3,544,480z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsSolidFull);
export default __webpack_public_path__ + "static/media/bars-solid-full.eb36a477744d956ee3a5c4407c1a9c99.svg";
export { ForwardRef as ReactComponent };